import router from "@/router";
import App from './App.vue'
import {createApp} from "vue";
import '@/assets/scss/styles.scss'
import '@/assets/css/ckeditor.css'

import axios from "axios";
import {createPinia} from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import ToastPlugin from "@/components/toast/Tostify";
import ObserverSentinel from "@/utils/ObserverSentinelUtils";

import Debug from "@/components/utils/Debug.vue";
import Input from "@/components/Input.vue"
import Multiselect from "@/components/Multiselect.vue"
import Button from "@/components/Button.vue"

import * as Sentry from "@sentry/vue";

axios.defaults.withCredentials = true;
axios.defaults.timeout = import.meta.env.VITE_APP_API_TIMEOUT as unknown as number;
axios.defaults.baseURL = import.meta.env.VITE_APP_API_URL;
axios.defaults.headers.common = {
    "Content-Type": "application/json",
    "Accept": "application/json"
}

axios.defaults.transformRequest = [(data) => {
    if (data instanceof FormData) {
        return data
    }

    if (!data) {
        data = {}
    }

    return JSON.stringify(data);
}];

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

if (import.meta.env.VITE_APP_ENV !== "main") {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_APP_SENTRY_DSN,
        release: import.meta.env.VITE_APP_VERSION_HASH,
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({router}),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: [window.location.origin],
            }),

            Sentry.replayCanvasIntegration(),
        ],

        enableLogs: true,

        tracesSampleRate: 1.0,

        tracePropagationTargets: ["localhost", "admin.epitome.studio"],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        environment: import.meta.env.VITE_APP_ENV,
    });

    const versionHash = import.meta.env.VITE_APP_VERSION_HASH;

    if (versionHash) {
        Sentry.setTag("version", versionHash);
    }
}

app.use(router);
app.use(pinia);
app.use(ToastPlugin);
app.use(ObserverSentinel);

app.component('Debug', Debug);
app.component('Input', Input);
app.component('Multiselect', Multiselect);
app.component('Button', Button);

app.mount("#app");